import { useDispatch, useSelector } from "react-redux";
import usePreviousPersistent from "./usePreviousPersistent";
import { selectSlot } from "store/game/selectors";
import { displayRandomItem } from "store/game";

export default function useSlot(slotIndex) {
  const slotHistory = useSelector(selectSlot(slotIndex));
  const slot = slotHistory[slotHistory.length - 1];
  const previousSlot = usePreviousPersistent(slot);
  const dispatch = useDispatch();
  const requestNewItem = () => dispatch(displayRandomItem(slotIndex));

  return [slot, requestNewItem, previousSlot];
}
